import React, {useContext} from "react"
import * as Constants from "../../../util/Constants";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {TrafficLightDeviceOverviewContext} from "../context/TrafficLightOverviewContext";

const UpdateDeviceDetailsResponse = () => {
    const {viewModel, dispatch} = useContext(TrafficLightDeviceOverviewContext);

    const getModalType = (updateResponseModalType) => {
        if(updateResponseModalType === Constants.MODAL_SUCCESS)
            return "success"
        else if(updateResponseModalType === Constants.MODAL_ERROR)
            return "error"
    }

    return (
        <Modal
            open={viewModel.showResponseModal === Constants.MODAL_SUCCESS || viewModel.showResponseModal === Constants.MODAL_ERROR}
            closeLabel="Close"
            describedById="modal-description"
            width={"500"}
        >
            <div>
                <Alert
                    type={getModalType(viewModel.showResponseModal)}
                    size="xlarge"
                >
                    <FormattedMessage id="message" defaultMessage="{message}"
                                      values={{message: viewModel.modalMessageToDisplay}}>
                    </FormattedMessage>
                </Alert>
            </div>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="small" onClick={() => dispatch({
                        type: "SHOW_UPDATE_RESPONSE_MODAL",
                        data: {modalState: Constants.MODAL_RESET, message: ''}
                    })}>
                        Close
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default UpdateDeviceDetailsResponse;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/modal/UpdateDeviceDetailsResponse.js